// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/transfer/v1/transfer_list.proto (package kitecorp.transferify.transfer.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { TransferFile, TransferSummary } from "./transfer_pb";
import { file_kitecorp_transferify_transfer_v1_transfer } from "./transfer_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/transfer/v1/transfer_list.proto.
 */
export const file_kitecorp_transferify_transfer_v1_transfer_list: GenFile = /*@__PURE__*/
  fileDesc("CjRraXRlY29ycC90cmFuc2ZlcmlmeS90cmFuc2Zlci92MS90cmFuc2Zlcl9saXN0LnByb3RvEiBraXRlY29ycC50cmFuc2ZlcmlmeS50cmFuc2Zlci52MSLwAQoUTGlzdFRyYW5zZmVyc1JlcXVlc3QSTgoEc29ydBgBIAEoDjI7LmtpdGVjb3JwLnRyYW5zZmVyaWZ5LnRyYW5zZmVyLnYxLkxpc3RUcmFuc2ZlcnNSZXF1ZXN0LlNvcnRIAIgBARIOCgZvZmZzZXQYAiABKAUibwoEU29ydBIUChBTT1JUX1VOU1BFQ0lGSUVEEAASDwoLU09SVF9ORVdFU1QQARIPCgtTT1JUX09MREVTVBACEhAKDFNPUlRfTEFSR0VTVBADEh0KGVNPUlRfTkVXRVNUX1RIRU5fU01BTExFU1QQBEIHCgVfc29ydCKgAQoVTGlzdFRyYW5zZmVyc1Jlc3BvbnNlEkQKCXRyYW5zZmVycxgBIAMoCzIxLmtpdGVjb3JwLnRyYW5zZmVyaWZ5LnRyYW5zZmVyLnYxLlRyYW5zZmVyU3VtbWFyeRIXCg90b3RhbF90cmFuc2ZlcnMYAiABKAUSEwoLdG90YWxfZmlsZXMYAyABKAMSEwoLdG90YWxfYnl0ZXMYBCABKAMiPwoYTGlzdFRyYW5zZmVyRmlsZXNSZXF1ZXN0EhMKC3RyYW5zZmVyX2lkGAEgASgJEg4KBm9mZnNldBgCIAEoBSJvChlMaXN0VHJhbnNmZXJGaWxlc1Jlc3BvbnNlEj0KBWZpbGVzGAEgAygLMi4ua2l0ZWNvcnAudHJhbnNmZXJpZnkudHJhbnNmZXIudjEuVHJhbnNmZXJGaWxlEhMKC3RvdGFsX2ZpbGVzGAIgASgFMsMCChNUcmFuc2Zlckxpc3RTZXJ2aWNlEo4BCg1MaXN0VHJhbnNmZXJzEjYua2l0ZWNvcnAudHJhbnNmZXJpZnkudHJhbnNmZXIudjEuTGlzdFRyYW5zZmVyc1JlcXVlc3QaNy5raXRlY29ycC50cmFuc2ZlcmlmeS50cmFuc2Zlci52MS5MaXN0VHJhbnNmZXJzUmVzcG9uc2UiDJACAYq1GAUKA3VzZRKaAQoRTGlzdFRyYW5zZmVyRmlsZXMSOi5raXRlY29ycC50cmFuc2ZlcmlmeS50cmFuc2Zlci52MS5MaXN0VHJhbnNmZXJGaWxlc1JlcXVlc3QaOy5raXRlY29ycC50cmFuc2ZlcmlmeS50cmFuc2Zlci52MS5MaXN0VHJhbnNmZXJGaWxlc1Jlc3BvbnNlIgyQAgGKtRgFCgN1c2VCRQouY29tLmtpdGVjb3JwLmNvbnRyYWN0cy50cmFuc2ZlcmlmeS50cmFuc2Zlci52MUIRVHJhbnNmZXJMaXN0UHJvdG9QAWIGcHJvdG8z", [file_kitecorp_options_v1_options, file_kitecorp_transferify_transfer_v1_transfer]);

/**
 * Asks for one page of the caller's transfers.
 *
 * @generated from message kitecorp.transferify.transfer.v1.ListTransfersRequest
 */
export type ListTransfersRequest = Message<"kitecorp.transferify.transfer.v1.ListTransfersRequest"> & {
  /**
   * The order. Absent: SORT_NEWEST.
   *
   * @generated from field: optional kitecorp.transferify.transfer.v1.ListTransfersRequest.Sort sort = 1;
   */
  sort?: ListTransfersRequest_Sort | undefined;

  /**
   * How many rows the caller already holds, from zero. The next page starts after them.
   *
   * @generated from field: int32 offset = 2;
   */
  offset: number;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.ListTransfersRequest.
 * Use `create(ListTransfersRequestSchema)` to create a new message.
 */
export const ListTransfersRequestSchema: GenMessage<ListTransfersRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_list, 0);

/**
 * The orders the list can be read in. The account's transfers are ordered as a whole before a page is cut, and every
 * order ends on the transfer id, so no page repeats or skips a row.
 *
 * @generated from enum kitecorp.transferify.transfer.v1.ListTransfersRequest.Sort
 */
export enum ListTransfersRequest_Sort {
  /**
   * No order given.
   *
   * @generated from enum value: SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The newest transfer first. A transfer recorded without a creation time comes last.
   *
   * @generated from enum value: SORT_NEWEST = 1;
   */
  NEWEST = 1,

  /**
   * The oldest transfer first. A transfer recorded without a creation time comes first.
   *
   * @generated from enum value: SORT_OLDEST = 2;
   */
  OLDEST = 2,

  /**
   * The largest transfer first. Transfers of one size come newest first.
   *
   * @generated from enum value: SORT_LARGEST = 3;
   */
  LARGEST = 3,

  /**
   * The newest transfer first. Transfers created at one instant come smaller first.
   *
   * @generated from enum value: SORT_NEWEST_THEN_SMALLEST = 4;
   */
  NEWEST_THEN_SMALLEST = 4,
}

/**
 * Describes the enum kitecorp.transferify.transfer.v1.ListTransfersRequest.Sort.
 */
export const ListTransfersRequest_SortSchema: GenEnum<ListTransfersRequest_Sort> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_transfer_v1_transfer_list, 0, 0);

/**
 * One page of the caller's transfers.
 *
 * @generated from message kitecorp.transferify.transfer.v1.ListTransfersResponse
 */
export type ListTransfersResponse = Message<"kitecorp.transferify.transfer.v1.ListTransfersResponse"> & {
  /**
   * The rows of the page, in the requested order.
   *
   * @generated from field: repeated kitecorp.transferify.transfer.v1.TransferSummary transfers = 1;
   */
  transfers: TransferSummary[];

  /**
   * How many transfers the account holds, not only the page.
   *
   * @generated from field: int32 total_transfers = 2;
   */
  totalTransfers: number;

  /**
   * How many files those transfers hold, whatever their upload status.
   *
   * @generated from field: int64 total_files = 3;
   */
  totalFiles: bigint;

  /**
   * Their size in bytes, summed the way each row's total_bytes is.
   *
   * @generated from field: int64 total_bytes = 4;
   */
  totalBytes: bigint;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.ListTransfersResponse.
 * Use `create(ListTransfersResponseSchema)` to create a new message.
 */
export const ListTransfersResponseSchema: GenMessage<ListTransfersResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_list, 1);

/**
 * Asks for the files of one transfer.
 *
 * @generated from message kitecorp.transferify.transfer.v1.ListTransferFilesRequest
 */
export type ListTransferFilesRequest = Message<"kitecorp.transferify.transfer.v1.ListTransferFilesRequest"> & {
  /**
   * The transfer's id, a UUID. The caller must own it.
   *
   * @generated from field: string transfer_id = 1;
   */
  transferId: string;

  /**
   * How many files the caller already holds, from zero. The next page starts after them.
   *
   * @generated from field: int32 offset = 2;
   */
  offset: number;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.ListTransferFilesRequest.
 * Use `create(ListTransferFilesRequestSchema)` to create a new message.
 */
export const ListTransferFilesRequestSchema: GenMessage<ListTransferFilesRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_list, 2);

/**
 * One page of a transfer's files.
 *
 * @generated from message kitecorp.transferify.transfer.v1.ListTransferFilesResponse
 */
export type ListTransferFilesResponse = Message<"kitecorp.transferify.transfer.v1.ListTransferFilesResponse"> & {
  /**
   * The files of the page, in the transfer's own file order.
   *
   * @generated from field: repeated kitecorp.transferify.transfer.v1.TransferFile files = 1;
   */
  files: TransferFile[];

  /**
   * How many files the transfer holds, not only the page.
   *
   * @generated from field: int32 total_files = 2;
   */
  totalFiles: number;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.ListTransferFilesResponse.
 * Use `create(ListTransferFilesResponseSchema)` to create a new message.
 */
export const ListTransferFilesResponseSchema: GenMessage<ListTransferFilesResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_list, 3);

/**
 * The transfers the signed-in account sent (kitecorp/contracts#92). Each call reads the transfers of the caller; the
 * account is never named in a message.
 *
 * @generated from service kitecorp.transferify.transfer.v1.TransferListService
 */
export const TransferListService: GenService<{
  /**
   * Reads one page of the caller's transfers, ordered by sort, with the totals of every transfer the account holds. A
   * page may end before the list does when its rows are large: the caller continues with the number of rows it holds as
   * the offset, and stops when it holds total_transfers. It changes nothing, so a client may repeat it freely.
   *
   * @generated from rpc kitecorp.transferify.transfer.v1.TransferListService.ListTransfers
   */
  listTransfers: {
    methodKind: "unary";
    input: typeof ListTransfersRequestSchema;
    output: typeof ListTransfersResponseSchema;
  },
  /**
   * Reads the files of one of the caller's transfers, starting after the first offset files. A page
   * holds the files after offset up to a size limit, so it may end before the last file: the caller continues with the
   * number of rows it holds as the offset, and stops when it holds total_files. It changes nothing, so a client may
   * repeat it freely.
   *
   * @generated from rpc kitecorp.transferify.transfer.v1.TransferListService.ListTransferFiles
   */
  listTransferFiles: {
    methodKind: "unary";
    input: typeof ListTransferFilesRequestSchema;
    output: typeof ListTransferFilesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_transfer_v1_transfer_list, 0);

